import React from 'react';

import MapPage from '../components/map/mapPage/MapPage';
import MapLinks from '../config/MapLinks';

export default () => {
    return MapPage(MapLinks.VEDENI);
};
